import { useState } from 'react';
import toast from 'react-hot-toast';
import { ITEMS } from '../data/data';
import { tl, metaOf } from '../utils/helpers';

export default function Navbar({ user, wlCount, theme, onThemeToggle }) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);

  const results = q.length > 1
    ? ITEMS.filter(i => i.title.toLowerCase().includes(q.toLowerCase())).slice(0, 5)
    : [];

  return (
    <nav style={{
      position: 'sticky', top: 0, zIndex: 900, height: 68,
      display: 'flex', alignItems: 'center',
      borderBottom: '1px solid var(--border)',
      background: theme === 'dark' ? 'rgba(4,5,10,0.92)' : 'rgba(244,242,238,0.95)',
      backdropFilter: 'blur(24px)',
      transition: 'background 0.35s',
    }}>
      <div style={{ maxWidth: 1380, margin: '0 auto', padding: '0 2rem', display: 'flex', alignItems: 'center', gap: '1.5rem', width: '100%' }}>

        {/* Logo */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', flexShrink: 0 }}>
          <div style={{
            width: 38, height: 38, borderRadius: 10, flexShrink: 0,
            background: 'conic-gradient(from 0deg,var(--gold),var(--teal),var(--violet),var(--rose),var(--gold))',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.1rem',
            boxShadow: '0 0 24px rgba(232,184,75,.4)', animation: 'gemSpin 8s linear infinite',
          }}>👁️</div>
          <span style={{ fontFamily: 'var(--font-display)', fontSize: '1.4rem', fontWeight: 700 }}>
            Think &amp; <span style={{ color: 'var(--gold)' }}>See</span>
          </span>
        </div>

        {/* Search */}
        <div style={{ flex: 1, maxWidth: 440, position: 'relative' }}>
          <span style={{ position: 'absolute', left: '0.9rem', top: '50%', transform: 'translateY(-50%)', color: 'var(--muted)', pointerEvents: 'none' }}>🔍</span>
          <input
            value={q}
            onChange={e => { setQ(e.target.value); setOpen(true); }}
            onFocus={() => setOpen(true)}
            onBlur={() => setTimeout(() => setOpen(false), 180)}
            placeholder="Search movies, books, products…"
            style={{
              width: '100%', background: 'var(--surface)', border: '1px solid var(--border)',
              borderRadius: 100, padding: '0.58rem 1rem 0.58rem 2.7rem',
              fontFamily: 'var(--font-body)', fontSize: '0.86rem', color: 'var(--text)', outline: 'none',
              transition: 'border-color 0.25s, box-shadow 0.25s',
            }}
            onFocusCapture={e => { e.target.style.borderColor = 'var(--teal)'; e.target.style.boxShadow = '0 0 0 3px rgba(0,212,180,.12)'; }}
            onBlurCapture={e => { e.target.style.borderColor = 'var(--border)'; e.target.style.boxShadow = 'none'; }}
          />
          {open && results.length > 0 && (
            <div style={{
              position: 'absolute', top: 'calc(100% + 8px)', left: 0, right: 0,
              background: 'var(--surface)', border: '1px solid var(--border2)', borderRadius: 14,
              overflow: 'hidden', boxShadow: '0 24px 70px rgba(0,0,0,.55)', zIndex: 200,
              animation: 'fadeIn 0.18s ease',
            }}>
              {results.map(it => (
                <div
                  key={it.id}
                  onMouseDown={() => { setQ(''); toast(`Viewing "${it.title}"`); }}
                  style={{ display: 'flex', alignItems: 'center', gap: '0.8rem', padding: '0.8rem 1rem', cursor: 'pointer', transition: 'background 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.background = 'var(--surface2)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <img src={it.img} alt={it.title} style={{ width: 42, height: 42, borderRadius: 8, objectFit: 'cover', flexShrink: 0 }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: '0.87rem', fontWeight: 700 }}>{it.title}</div>
                    <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.61rem', color: 'var(--muted)', marginTop: 2 }}>{tl(it.type)} · {metaOf(it)}</div>
                  </div>
                  <span style={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', color: 'var(--teal)', flexShrink: 0 }}>★{it.score}%</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Actions */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.55rem', marginLeft: 'auto' }}>
          {[
            { icon: '📋', label: 'Watchlist', badge: wlCount, action: () => toast(`Watchlist: ${wlCount} items`) },
            { icon: '🔔', label: 'Notifications', action: () => toast('Notifications coming soon!') },
          ].map(({ icon, label, badge, action }) => (
            <button key={label} onClick={action} title={label} style={{
              width: 38, height: 38, borderRadius: 9, background: 'var(--surface)',
              border: '1px solid var(--border)', color: 'var(--text)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: '1rem', position: 'relative', transition: 'all 0.25s',
            }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--teal)'; e.currentTarget.style.boxShadow = '0 0 16px rgba(0,212,180,.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.boxShadow = 'none'; }}
            >
              {icon}
              {badge > 0 && (
                <span style={{ position: 'absolute', top: -5, right: -5, background: 'var(--rose)', color: '#fff', minWidth: 16, height: 16, borderRadius: 8, fontSize: '0.55rem', fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 3px' }}>{badge}</span>
              )}
            </button>
          ))}

          <button onClick={onThemeToggle} style={{
            width: 38, height: 38, borderRadius: 9, background: 'var(--surface)',
            border: '1px solid var(--border)', color: 'var(--text)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1rem',
            transition: 'all 0.25s',
          }}>{theme === 'dark' ? '☀️' : '🌙'}</button>

          <div style={{
            height: 38, padding: '0 1rem', gap: '0.5rem', borderRadius: 100,
            display: 'flex', alignItems: 'center', background: 'var(--surface)',
            border: '1px solid var(--border)', fontSize: '0.83rem', fontWeight: 700,
          }}>
            <div style={{ width: 26, height: 26, borderRadius: '50%', background: user.bg, color: user.color, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.75rem', fontWeight: 800 }}>{user.av}</div>
            {user.name}
          </div>
        </div>
      </div>
    </nav>
  );
}
